export default {
  REGISTRATION_TYPE: {
    LOGIN: "login",
    SIGN_UP: "sign-up",
    FORGOT_PASSWORD: "forgot-password",
  },
  ARTWORKS_PAGE_SIZE: 24,
  artistExpertLevel: 1,
};
